<template>
  <div class="watermark-box" ref="watermarkBox">
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    id1: {
      type: Number,
      required: true, // 第一个 ID 必须传入
    },
    id2: {
      type: Number,
      required: true, // 第二个 ID 必须传入
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.addWatermark(`${this.userInfo.phone.slice(0, 6)}     ${this.userInfo.phone.slice(5, 11)}`, 100, 80);
  },
  methods: {
    addWatermark(text, width, height) {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");

      // 设置水印样式
      ctx.font = "14px Arial";
      ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // 旋转并绘制水印文字
      ctx.translate(width / 2, height / 2);
      ctx.rotate((-30 * Math.PI) / 180);
      ctx.fillText(text, 0, 0);

      // 生成水印背景
      const watermark = canvas.toDataURL("image/png");
      const box = this.$refs.watermarkBox;
      box.style.backgroundImage = `url(${watermark})`;
      box.style.backgroundRepeat = "repeat";
      box.style.backgroundSize = `${width}px ${height}px`;
    },
  },
};
</script>

<style scoped>
.watermark-box {
  position: relative;
  width: 690px;
  height: 172px;
  /* background: #f9f9f9; */
  overflow: hidden;
  pointer-events: none; /* 让水印层不阻挡点击 */
}
</style>



// WEBPACK FOOTER //
// src/components/WaterMark.vue